import { RootState } from '@/shared/store'
import { createSelector, EntityId } from '@reduxjs/toolkit'

import { planningStopsAdapter } from '../adapters/planningStopsAdapter'

export const planningStopsSelectors = planningStopsAdapter.getSelectors<RootState>(
  (state) => state.planningStops,
)

export const selectPlanningStopsByIds = createSelector(
  [planningStopsSelectors.selectEntities, (_, ids: EntityId[]) => ids],
  (planningStops, ids) => {
    return ids?.map(id => planningStops?.[id] || null)
      ?.filter(stop => stop != null)
      ?.sort((a, b) => a.sequence - b.sequence)
      || []
  },
)
